import "./TemplatesMenu.scss";

export default function UseCasesMenu() {
  return (
    <div className={"templates-menu pricing-menu"}>
      <ul className="pricing-links">
        <li>
          <a href="/feature/restaurant-groups.html">Restaurant Groups</a>
        </li>
        <li>
          <a href="/feature/hotels.html">Hotels & Resorts</a>
        </li>
        <li>
          <a href="/feature/senior-living.html">Senior Living</a>
        </li>
      </ul>
    </div>
  );
}
